/**
 * Centralized query keys. Hierarchical so we can invalidate scoped subsets
 * cleanly (e.g. all character lists, or one specific scene's shots).
 */

export const qk = {
  projects: ["projects"] as const,
  project: (id: number) => ["projects", id] as const,

  characters: (projectId: number) => ["projects", projectId, "characters"] as const,
  character: (id: number) => ["characters", id] as const,

  costumes: (projectId: number) => ["projects", projectId, "costumes"] as const,
  costume: (id: number) => ["costumes", id] as const,

  locations: (projectId: number) => ["projects", projectId, "locations"] as const,
  location: (id: number) => ["locations", id] as const,

  props: (projectId: number) => ["projects", projectId, "props"] as const,
  prop: (id: number) => ["props", id] as const,

  scenes: (projectId: number) => ["projects", projectId, "scenes"] as const,
  scene: (id: number) => ["scenes", id] as const,

  shots: (sceneId: number) => ["scenes", sceneId, "shots"] as const,
  shot: (id: number) => ["shots", id] as const,

  promptManifest: (projectId: number) => ["projects", projectId, "prompts"] as const,

  adapterSettings: ["settings", "adapters"] as const,

  // Auth — singleton cache for the current session.
  authMe: ["auth", "me"] as const,

  userDraft: (kind: string) => ["user-drafts", kind] as const,

  screenplay: (id: number) => ["screenplays", "detail", id] as const,
  screenplayByProject: (projectId: number) => ["screenplays", "byProject", projectId] as const,

  // Creations — the cross-tool "things I made" library.
  creations: ["creations"] as const,
  creationsList: (filter?: { type?: string }) =>
    filter?.type ? ["creations", "list", filter.type] as const : ["creations", "list"] as const,

  /** Mutation keys (used with useMutation's `mutationKey` and useIsMutating). */
  mk: {
    breakdown: (sceneId: number) => ["breakdown", sceneId] as const,
    generateProject: (projectId: number) => ["generate-project", projectId] as const,
  },
};
